import {
  React,
  Component,
  axios,
  routes,
  withCookies,
  windowSize,
} from 'imports/CommonImports';

import {
  TextField,
  CircularProgress
} from 'material-ui';

import {ForgotPassword} from 'imports/ComponentsImports';

import {
  Logo,
  ImageLogin,
  PrimaryButton
} from 'imports/DesignImports';

const styles = {
  titleContainer: {
    'backgroundColor': '#EF5350',
    'height': '25%',
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'color': 'white',
    'flexDirection': 'column',
    'overflow': 'hidden'
  },
  inputContainer: {
    'margin': '20px 20px 10px 20px'
  },
  button: {
    'backgroundColor': '#27ab99',
    'margin': '20px 20px 20px 20px',
    'color': 'white',
    'width': '300px'
  },
  forgotPassword: {
    marginBottom: '1.5em',
    marginTop: '1em',
  },
}
class Login extends Component {
  constructor(props){
    super(props);
    this.state = {
      username: '',
      password: '',
      loading: false,
      error: false
    }
  }

  render() {
    return (
      <div style={{display:'flex', alignItems: 'strech', width:'100%'}}>
        <div style={{width:'50%', textAlign: 'center', marginTop:this.props.windowHeight/5, backgroundColor:'#FFFFFF', zIndex:'1000'}}>
          <img src={Logo} alt="Índice i3" style={{zIndex:'1000'}}/>
            <div style={{marginTop: '20px'}}>
            {this.state.error ? <div style={{textAlign: 'center', color:'#ba0f0f'}}>Hubo un error en el login, por favor intenta nuevamente</div> : null}
            </div>
            {
              this.state.loading
              ?
              <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
                <CircularProgress color='#9e9e9e' size={80} thickness={5} />
              </div>
              :
                [<div style={styles.inputContainer} key="login-form">
                  <TextField
                  style={styles.TextField}
                  value={this.state.username}
                  floatingLabelText="Usuario"
                  onChange={this.handleChange}
                  name="username"
                  onKeyPress={this.keyPressed}
                  />
                  <br />
                  <TextField
                  style={styles.TextField}
                  value={this.state.password}
                  floatingLabelText="Contraseña"
                  type="password"
                  onChange={this.handleChange}
                  name="password"
                  onKeyPress={this.keyPressed}
                  />
                </div>,
                <ForgotPassword style={styles.forgotPassword} key='forgot-password'/>,
                <PrimaryButton onClick={() => {this.login(this.props.history, this.props.registerCookie, this.setError)}} label="INICIAR SESIÓN" key="loginButton"/>]
            }
        </div>
        <div style={{display:'flex', width: '50%', backgroundImage: 'url('+ ImageLogin+')', backgroundSize: 'cover', height:this.props.windowHeight/0.9}}></div>
      </div>
    );
  }

  keyPressed = (event) => {
    if(event.key === 'Enter'){
      this.login(this.props.history, this.props.registerToken, this.setError);
    }
  }

  setError = (value) => {
    this.setState({error: value})
  }

  login = (history, registerCookie, setError) => {
    this.setState({loading: true});
    axios.post(routes.host + routes.authenticate, {
      username: this.state.username,
      password: this.state.password
    })//TODO: Verify Token
    .then((response) => {
      if(response.status === 200){
        this.props.cookies.set('token', JSON.stringify(response.data.token), { path: '/' });
        this.props.cookies.set('user', JSON.stringify(response.data.user), { path: '/' });
        this.props.cookies.set('current_stage', JSON.stringify(response.data.current_stage), { path: '/' });
        this.setState({
          loading: false,
          error: false
        })
        history.push('home');
      }
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        loading: false,
        error: true
      })
    });
  }

  handleChange = (event) => {
    var newState = {};
    newState[event.target.name] = event.target.value
    this.setState(newState)
  }
}

export default windowSize(withCookies(Login));



// WEBPACK FOOTER //
// ./src/components/common/Login.js